import { FullWizardItem } from '../../contexts/WizardContext/WizardContext';

export const getInitialPrice = (
  itemData: FullWizardItem,
  increasedPriceExchangeAllowed: boolean,
) => {
  return increasedPriceExchangeAllowed ? itemData.priceBand[1] : itemData.originalPrice;
};
